import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
    // COORDINATORS: (communityId) => ({
    //     url: `coordinator-list/${communityId}`,
    //     method: "get",
    // }),

    // REPORTERS: (communityId) => ({
    //     url: `reporter-list/${communityId}`,
    //     method: "get",
    // }),

    SAVE_COORDINATOR_ICON: {
        url: "instellingen/bestuur/saveOrUpdatePlanning",
        method: "post",
    },

    // REPORTER_ADD_REMOVE: {
    //     url: "bestuur/reporter/add-remove",
    //     method: "post",
    // },
};

// export const useCoordinators = (communityId) =>
//     useApiFetcherSWR(API_ENDPOINT.COORDINATORS(communityId));

// export const useReporters = (communityId) =>
//     useApiFetcherSWR(API_ENDPOINT.REPORTERS(communityId));

export const useSaveCoordinatorIcon = () =>
    useApiFetcherSWR(API_ENDPOINT.SAVE_COORDINATOR_ICON);

// export const useReporterAddRemove = () =>
//     useApiFetcherSWR(API_ENDPOINT.REPORTER_ADD_REMOVE);